export const formatDistance = (km?: number) =>
  typeof km === 'number' ? `${km.toFixed(2)} km` : '';
